import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[Tickets SetFilter] Action',
  ResetFilter: '[Tickets ResetFilter] Action',
}

const initialTicketsState: ITicketsState = {
  filter: {
    search: '',
    typeId: '',
    categoryId: '',
    statusIds: [],
    priorityId: '',
    createdBy: null,
    assigned: false,
    assignedTo: null,
    assignedToInitialized: false,
    dateFrom: '',
    dateTo: '',
    ignoreClosed: true,
    dueInHours: null,
    siteId: '',
  },
}

export interface ITicketsState {
  filter?: {
    search: string
    typeId: string
    categoryId: string
    statusIds: string[]
    priorityId: string
    createdBy: any
    assigned: boolean
    assignedTo: any
    assignedToInitialized: boolean
    dateFrom: string
    dateTo: string
    ignoreClosed: boolean
    dueInHours: number | null
    siteId: string
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-Tickets', whitelist: ['filter']},
  (state: ITicketsState = initialTicketsState, action: ActionWithPayload<ITicketsState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialTicketsState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
